import { MetabaseReport } from "../../../model/CommonModel";
import CommonComponent from "../CommonComponent";

const META_DAILY_SCAN_REPORT = 283 ;

function ManifestationIRSReport() {
    const reportData: MetabaseReport = {
        reportType: "question",
        reportId: META_DAILY_SCAN_REPORT,
        reportName: "Manifestation IRS report",
    };

    return (
        <>
            <CommonComponent selectedReportData={reportData} params={{}} />
        </>
    );
}

export default ManifestationIRSReport;